import React from 'react'
import PropTypes from 'prop-types'
import { createComponent } from '@ycos/fela'
import Picture from './Picture'

const BackgroundImageContainer = createComponent('BackgroundImage', ({ width, height, stickyText, additionalStyles }) => {
  return {
    position: 'relative',
    width,
    height,
    maxHeight: stickyText ? '100vh' : undefined,
    overflow: stickyText ? undefined : 'hidden',
    ...additionalStyles
  }
})

const BackgroundOpacityContainer = createComponent('BackgroundOpacity', ({ opacity, opacityColor, opacityContainerStyles }) => ({
  opacity,
  position: 'absolute',
  zIndex: 1,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  background: opacityColor,
  ...opacityContainerStyles
}))

const ContentContainer = createComponent('Content', () => ({
  zIndex: 2,
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
}))

export default class BackgroundPicture extends React.PureComponent {
  render() {
    const {
      opacity,
      opacityColor,
      opacityContainerStyles,
      children,
      width,
      height,
      images,
      imagesphere,
      verticalAlignment, // TODO: change verticalAlignment prop name to be something like focalPoint. object-position can be used for vertical or horizontal alignment
      stickyText,
      additionalStyles,
      lazy,
      widths,
      forceAspectRatioDesktop,
      forceAspectRatioMobile,
      fetchPriority
    } = this.props

    return (
      <BackgroundImageContainer width={width} height={height} stickyText={stickyText} additionalStyles={additionalStyles}>
        <Picture
          fetchPriority={fetchPriority}
          images={images}
          imagesphere={imagesphere}
          style={{
            objectPosition: verticalAlignment || 'center',
            objectFit: 'cover',
            height: forceAspectRatioMobile ? '100%' : height,
            'screen-medium': {
              height: forceAspectRatioDesktop ? '100%' : height
            }
          }}
          stickyText={stickyText}
          lazy={lazy}
          widths={widths}
          forceAspectRatioDesktop={forceAspectRatioDesktop}
          forceAspectRatioMobile={forceAspectRatioMobile}
        />
        {opacity ? <BackgroundOpacityContainer opacity={opacity} opacityColor={opacityColor} opacityContainerStyles={opacityContainerStyles} /> : null}
        {opacity ? <ContentContainer>{children}</ContentContainer> : children}
      </BackgroundImageContainer>
    )
  }
}

BackgroundPicture.defaultProps = {
  lazy: true,
  width: '100%',
  height: 'auto',
  additionalStyles: {},
  opacityColor: 'black',
  opacityContainerStyles: {}
}

BackgroundPicture.propTypes = {
  forceAspectRatioMobile: PropTypes.number,
  forceAspectRatioDesktop: PropTypes.number,
  additionalStyles: PropTypes.object,
  opacityColor: PropTypes.string,
  opacityContainerStyles: PropTypes.object,
  fetchPriority: PropTypes.string
}
